import { useState } from "react";
import styled from "styled-components";
import { Select, Form } from "antd";

import colors from "constants/palette";

const months = [
  {
    title: "فروردین",
    index: "01",
  },
  {
    title: "اردیبهشت",
    index: "02",
  },
  {
    title: "خرداد",
    index: "03",
  },
  {
    title: "تیر",
    index: "04",
  },
  {
    title: "مرداد",
    index: "05",
  },
  {
    title: "شهریور",
    index: "06",
  },
  {
    title: "مهر",
    index: "07",
  },
  {
    title: "آبان",
    index: "08",
  },
  {
    title: "آذر",
    index: "09",
  },
  {
    title: "دی",
    index: "10",
  },
  {
    title: "بهمن",
    index: "11",
  },
  {
    title: "اسفند",
    index: "12",
  },
];

export default function Month(props) {
  const { currentYear } = props;

  const [yaersOptions, setYaersOptions] = useState(() =>
    Array.from({ length: 3 }, (_, i) => currentYear + i)
  );

  return (
    <Container>
      <StyledItem name={props?.yearName ? props.yearName : "year"}>
        <CustomSelect size="large">
          {yaersOptions &&
            yaersOptions.map((item, key) => (
              <CustomOption value={item} key={key}>
                {item}
              </CustomOption>
            ))}
        </CustomSelect>
      </StyledItem>
      <StyledItem name={props?.monthName ? props.monthName : "month"}>
        <CustomSelect size="large">
          {months &&
            months.map((item, key) => (
              <CustomOption value={item.index} key={key}>
                {item.title}
              </CustomOption>
            ))}
        </CustomSelect>
      </StyledItem>
    </Container>
  );
}
const Container = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
`;
const CustomSelect = styled(Select)`
  min-width: 40px;

  direction: rtl;
  text-align: center;
  & .ant-select-selector {
    border-radius: ${({ borderradius }) =>
      borderradius ? borderradius : "3px"} !important;
    background: ${colors.white + "50"} !important;
    color: ${colors.dark};
  }
  & * {
    fill: ${colors.dark} !important;
  }
`;
const CustomOption = styled(Select.Option)`
  width: 100%;
  direction: rtl;

  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  background: ${colors.white};
`;

const StyledItem = styled(Form.Item)`
  width: 45%;
`;
